import PatientLayout from '@/components/patient/PatientLayout';
import type { PageProps } from './Show';
import ClinicalNotesPage from './ClinicalNotes';
import type { Props as ClinicalNotesProps } from './ClinicalNotes';

type NotesProps = PageProps & ClinicalNotesProps;

export default function Notes(props: NotesProps) {
  const { patient, stats, charts, notes, selectedNoteId, clinicalNotesMeta } = props;

  return (
    <PatientLayout patient={patient} stats={stats} charts={charts} activeTab="notes">
      <ClinicalNotesPage
        patient={{ ...patient, display_name: patient.name } as ClinicalNotesProps['patient']}
        notes={notes}
        selectedNoteId={selectedNoteId}
        clinicalNotesMeta={clinicalNotesMeta}
        hideChrome
      />
    </PatientLayout>
  );
}
